export default __webpack_public_path__ + "static/media/icon_rpa.1bbe2331.svg";